import { render, staticRenderFns } from "./NgoInfographic.vue?vue&type=template&id=88f28648&scoped=true&"
import script from "./NgoInfographic.vue?vue&type=script&lang=js&"
export * from "./NgoInfographic.vue?vue&type=script&lang=js&"
import style0 from "./NgoInfographic.vue?vue&type=style&index=0&id=88f28648&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f28648",
  null
  
)

export default component.exports